import { toast } from "react-toastify";
import { success, custom, failure } from "./utilities.js";
import { refundOrderService } from "../../services";
import { getCurrencyCode } from "../../shared/utility.js";
import { orderConstants, globalConstants } from "../../constants";

export const getRefundOrders = (id) => {
  return (dispatch) => {
    refundOrderService
      .getRefundOrders(id)
      .then((response) => {
        dispatch(success(response, orderConstants.GET_ORDERS_BY_ID));
        if (response?.customer_id) {
          dispatch(getCustomerById(response?.customer_id));
        }

        const currencyCode = getCurrencyCode(response?.currency_code);
        dispatch(success(currencyCode, orderConstants.CURRENCY_CODE));
      })
      .catch((error) => {
        console.error(error);
        toast.error(error);
      });
  };
};

export const getProductsByOrderId = (id) => {
  return (dispatch) => {
    refundOrderService
      .getProductsByOrderId(id)
      .then((response) => {
        dispatch(success(response, orderConstants.GET_PRODUCTS_BY_ORDERS_ID));
      })
      .catch((error) => {
        console.error(error);
        toast.error(error);
      });
  };
};

export const getCustomerById = (id) => {
  return (dispatch) => {
    refundOrderService
      .getCustomerById(id)
      .then((response) => {
        dispatch(success(response, orderConstants.GET_CUSTOMER_BY_ID));
      })
      .catch((error) => {
        console.error(error);
        toast.error(error);
      });
  };
};

export const addRefundOrder = (data, id) => {
  return (dispatch) => {
    dispatch(
      custom(orderConstants.ADD_REFUND, globalConstants.BUTTON_SPINNER_ACTIVATE)
    );
    refundOrderService
      .addRefundOrder(data, id)
      .then((response) => {
        toast.success("Refund processed successfully!");
        dispatch({ type: orderConstants.REFUND_SUCCESS });
      })
      .catch((error) => {
        console.error(error);
        toast.error(error);
      })
      .finally(() => {
        dispatch(
          custom(
            orderConstants.ADD_REFUND,
            globalConstants.BUTTON_SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const refundOrderActions = {
  getRefundOrders,
  getCustomerById,
  getProductsByOrderId,
  addRefundOrder,
};
